export function pathJoin(...paths: string[]) {
  return paths.reduce((p, c) => {
    if(!p) {
      return c;
    } else {
      c = c.replace(/^[\/\.]+/, '');
      if(c) {
        return `${p.replace(/\/*$/, '/')}${c}`;
      }
      return p;
    }
  }, '');
}
